<template>
  <th>
    <v-menu class="font-weight-small text-center">
      <template v-slot:activator="{ on }">
        <v-text-field
          clearable
          readonly
          small
          label=""
          v-on="on"
          v-model="selected"
          @click:clear="clearDate"
          class="font-weight-small text-center"
          single-line
        ></v-text-field>
      </template>
      <v-date-picker
        no-title
        locale="RU"
        @change="changed"
        v-model="selected"
        class="font-weight-small text-center"
      ></v-date-picker>
    </v-menu>
  </th>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "DatePicker",
  data() {
    return {
      selected: "",
    };
  },
  methods: {
    ...mapActions(["setFilterKey", "deleteFilterKey"]),
    changed: function () {
      // console.log("Date changed: " + this.selected);
      let key = "timestamp__ts__date";
      let value = this.selected;
      // console.log("Selected: " + value);

      this.setFilterKey({ key, value });
      this.$emit("filter_update");
    },
    clearDate: function () {
      // console.log("Deleting date");
      let key = "timestamp__ts__date";
      let value = "";
      // console.log("Selected: " + value);
      this.setFilterKey({ key, value });
      this.$emit("filter_update");
    },
  },
};
</script>


<style scoped>
.menu {
  width: 100px;
  font-weight: 7.5px;
  text-overflow: clip;
}
.date {
  width: 95px;
  right: 0;
}
</style>